/**
 * WhatsApp Bubble Component
 * Displays a floating bubble that opens WhatsApp chat in a new tab
 */
export class WhatsAppBubble extends HTMLElement {
  #button;

  connectedCallback() {
    this.#setupBubble();
  }

  #setupBubble() {
    this.#button = this.querySelector('[data-whatsapp-button]');

    if (this.#button) {
      this.#button.addEventListener('click', (e) => {
        e.preventDefault();
        this.#openWhatsApp();
      });

      // Optional: Add keyboard support
      this.#button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.#openWhatsApp();
        }
      });
    }
  }

  #openWhatsApp() {
    const phoneNumber = this.dataset.phoneNumber;
    const message = this.dataset.message;

    if (!phoneNumber) {
      console.warn('WhatsApp bubble: phone number not provided');
      return;
    }

    const encodedMessage = message ? encodeURIComponent(message) : '';
    const whatsappUrl = encodedMessage
      ? `https://wa.me/${phoneNumber}?text=${encodedMessage}`
      : `https://wa.me/${phoneNumber}`;

    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  }
}

customElements.define('whatsapp-bubble', WhatsAppBubble);
